module.exports = __webpack_public_path__ + "static/media/ksyz-preroll.426fe1ff.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/preroll/ksyz-preroll.mp3
// module id = 32
// module chunks = 0